'use client';
import { visibleScrollSelector } from '@lib/store/slices/ComponentsSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { animated, useSpring } from '@react-spring/web';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

import AnimateLines from '@components/animate-lines/AnimateLines';
import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import Switch from '@components/switch/Switch';
import ROUTES from '@lib/constants/routes';
import ScrollHelperStandart from '@lib/tools/helpers/ScrollHelperStandart';
import { useRouter } from 'next/navigation';
import styles from './page.module.scss';

const breadCrumbsApi = {
  color: '#1C1C1C',
  crumbs: [
    {
      id: 1,
      text: 'Главная',
      link: ROUTES.root,
    },
    {
      id: 2,
      text: 'Благоустройство',
    },
  ],
};

const TemplateLandscaping = ({ children }) => {
  const [toggle0, setToggle0] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [toggle2, setToggle2] = useState(false);
  const [toggle3, setToggle3] = useState(false);
  const router = useRouter();

  const svgRefFirst = useRef(null);
  const svgReftsar = useRef(null);
  const svgReftsar1 = useRef(null);
  const svgReftsar2 = useRef(null);

  const { isMobile } = useViewport();

  const visibleScroll = useSelector(visibleScrollSelector);

  const opacityStyle = useSpring({
    config: { duration: 500 },
    opacity: visibleScroll ? 0 : 1,
    delay: 0,
  });

  const opacityStyleRevers = useSpring({
    config: { duration: 10 },
    opacity: !visibleScroll ? 1 : 0,
    delay: 0,
  });

  useLayoutEffect(() => {
    if (svgReftsar?.current) {
      let st5 = null;
      const element = svgReftsar.current;
      setTimeout(() => {
        st5 = ScrollTrigger.create({
          trigger: element,
          start: 'top top', // end: "bottom bottom",
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          duration: 0.5,
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle(() => true);
            }, 400);
          },
        });
        return () => {
          st5.kill();
        };
      }, 800);
    }
  }, [isMobile]);

  useLayoutEffect(() => {
    if (svgRefFirst?.current) {
      let st4 = null;
      const element = svgRefFirst.current;
      setTimeout(() => {
        st4 = ScrollTrigger.create({
          trigger: element,
          start: -20, // end: "bottom bottom",
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle0(() => true);
            }, 400);
          },
        });
        return () => {
          st4.kill();
        };
      }, 500);
    }
  }, [isMobile]);

  useLayoutEffect(() => {
    if (svgReftsar1?.current) {
      let st5 = null;
      const element = svgReftsar1.current;
      setTimeout(() => {
        st5 = ScrollTrigger.create({
          trigger: element,
          start: 'top center', // end: "bottom bottom",
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle2(() => true);
            }, 400);
          },
        });
        return () => {
          st5.kill();
        };
      }, 1000);
    }
  }, [isMobile]);

  useLayoutEffect(() => {
    if (svgReftsar2?.current) {
      let st5 = null;
      const element = svgReftsar2.current;
      setTimeout(() => {
        st5 = ScrollTrigger.create({
          trigger: element,
          start: 100, // end: "bottom bottom",
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              setToggle3(() => true);
            }, 400);
          },
        });
        return () => {
          st5.kill();
        };
      }, 300);
    }
  }, [isMobile]);

  return (
    <animated.div style={visibleScroll ? opacityStyleRevers : opacityStyle} className={styles.parallaxContainer}>
      <div className={styles.bredCrumbs_block}>
        <BreadCrumbs item={breadCrumbsApi} />
      </div>

      {!isMobile && (
        <div className={styles.landscpSvgFirst} ref={svgRefFirst}>
          <AnimateLines id='vector_landscp_1' className={styles.svgClassFirst} toggle={toggle0} />
        </div>
      )}
      {!isMobile && (
        <div className={styles.landscpSvg} ref={svgReftsar}>
          <AnimateLines id='vector_landscp_3' className={styles.svgClass} toggle={toggle} />
        </div>
      )}
      {!isMobile && (
        <div className={styles.landscpSvgTwo} ref={svgReftsar1}>
          <AnimateLines id='vector_landscp_5' className={styles.svgClassTwo} toggle={toggle2} />
        </div>
      )}
      {isMobile && (
        <div className={styles.landscpSvgThree} ref={svgReftsar2}>
          <AnimateLines id='vector_landscp_mob' className={styles.svgClassThee} toggle={toggle3} />
        </div>
      )}
      {children}
      <div className={styles.landscapingPageButtonWrapper}>
        <Switch
          className={styles.button}
          switchText='Выбрать квартиру'
          black
          handleSwitch={() => router.push(ROUTES.flats.list)}
          testId='landscapingFormOpen'
        />
      </div>
      <ScrollHelperStandart />
    </animated.div>
  );
};

export default TemplateLandscaping;
